import { f as r } from "./index.es30.js";
import { _ as e } from "./index.es280.js";
import { _ as o } from "./index.es281.js";
var a = r, s = e, f = o;
function n(t) {
  return f(s(t, void 0, a), t + "");
}
var l = n;
export {
  l as _
};
//# sourceMappingURL=index.es100.js.map
